export interface InputFomat {
    type?: string;
    value?: string;
    placeholder?: string;
    pattern?: string;
    required?: boolean;
    label?: string;
    default?: string;
    options?: { [key: string]: string };
    allow_multi_selection?: boolean;
    allowed_fileextensions?: string[];
    id?: string;
    min? : number;
    max? : number;
    step?: number;
    name?: string;
    checked?: boolean;
    helperText?: string;
}